<span class="sm-image-preview">
  <img
    #triggerImage
    class="sm-image-preview__trigger"
    [src]="src"
    [alt]="alt"
    (error)="imageError.emit()"
    (pointerdown)="handleTriggerPointerDown($event)"
    (pointermove)="handleTriggerPointerMove($event)"
    (pointerup)="handleTriggerPointerEnd($event)"
    (pointercancel)="handleTriggerPointerEnd($event)"
    (mouseenter)="handleTriggerMouseEnter($event)"
    (mouseleave)="handleTriggerMouseLeave($event)"
    (click)="handleTriggerClick($event)">

</span>

@if (galleryOpen) {
  <sm-photo-gallery [images]="loadGalleryImages || (sourceKind && sourceId) ? loadedGalleryImages : galleryImages ?? []"
    [loading]="galleryLoading" [loadFailed]="galleryLoadFailed" [itemName]="alt" [isOpen]="true"
    [portalToBody]="true" (closed)="closePreview()" />
}
